import { render } from "./TablesList.vue?vue&type=template&id=7b7ceafa&scoped=true"
import script from "./TablesList.vue?vue&type=script&lang=js"
export * from "./TablesList.vue?vue&type=script&lang=js"

import "./TablesList.vue?vue&type=style&index=0&id=7b7ceafa&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b7ceafa"]])

export default __exports__